<p>reservation-summary-dialog-handler works!</p>
